<div class="pie-chart" style="position: relative" [style.width]="width" [style.height]="height + 'px'" *ngIf="width">
  <canvas id="barChart{{id}}" [style.width]="width"></canvas>
  <div class="d-flex justify-content-end mb-3">
    <span class="block-unit">(tuổi)</span>
  </div>
</div>
